import { isSafeUrl } from './urlSafety';

export type NavigationTarget = '_self' | '_blank';

export function navigateToUrl(url: string, target: NavigationTarget = '_self'): boolean {
  if (!isSafeUrl(url) || typeof window === 'undefined') return false;

  if (target === '_self') {
    try {
      window.open(url, '_self');
      return true;
    } catch {
      try {
        window.location.assign(url);
        return true;
      } catch {
        return false;
      }
    }
  }

  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
